
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.legal {
  display: grid;
  grid-template-columns: 1fr [content] 12fr 1fr;
}

.legal-wrapper {
  grid-area: content;
  max-width: $container-max-width;
  margin: 0 auto;
  margin-bottom: 3.75rem;
}

.legal-heading {
  margin-bottom: 3rem;

  @include media-query(tablet) {
    margin-bottom: 5rem;
  }
}

.legal-content {
  display: grid;
  grid-gap: 4rem;
  grid-template-columns: minmax(0, 1fr);

  @include media-query(tablet) {
    grid-template-columns: 250px minmax(0, auto);
    grid-gap: 8rem;
  }
}

@include media-query(tablet) {
  .legal-wrapper {
    margin-bottom: 7.5rem;
  }
}

@media print {
  footer,
  .legal-content__directory {
    display: none;
  }
}
`